import React from 'react';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel, trimTextOnBlur } from '../utils/formHelpers';
import { outlinedFieldProps } from '../utils/fieldStyles';

const TextareaField = ({ field, data, change, hasError, errorMessage }) => {
    const textValue = data[field.key] || '';
    const maxLen = field.maxLength;
    return (
        <TextField
            {...outlinedFieldProps}
            label={<FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />}
            multiline
            rows={4}
            placeholder={field.placeholder}
            value={textValue}
            onChange={(e) => {
                const next = e.target.value;
                if (maxLen && next.length > maxLen) return;
                change(field.key, next);
            }}
            onBlur={(e) => trimTextOnBlur(e.target.value, (next) => change(field.key, next))}
            error={hasError}
            helperText={
                hasError
                    ? (errorMessage || 'This field is required')
                    : (maxLen ? `${textValue.length}/${maxLen}` : '')
            }
            inputProps={maxLen ? { maxLength: maxLen } : undefined}
        />
    );
};

export default TextareaField;
